import { render, staticRenderFns } from "./MovingFolder.vue?vue&type=template&id=a49598ba"
import script from "./MovingFolder.vue?vue&type=script&lang=ts"
export * from "./MovingFolder.vue?vue&type=script&lang=ts"
import style0 from "./MovingFolder.vue?vue&type=style&index=0&id=a49598ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports